import * as React from 'react';
import TwoColRow from './TwoColRow';
const PersonalDebtSummary = ({ value, i18n, formatNumber }) => (React.createElement(React.Fragment, null,
    React.createElement(TwoColRow, { label: i18n('controlpoint.totalamount'), value: formatNumber(value.currentDebt.numberOfAJudgments +
            value.currentDebt.numberOfEJudgments) }),
    React.createElement(TwoColRow, { label: i18n('controlpoint.totalsum'), value: formatNumber(value.currentDebt.amountInAJudgments +
            value.currentDebt.amountInEJudgments) })));
export default PersonalDebtSummary;
